<nav class="navbar navbar-expand-lg" [class.navbar-sticky]="isSticky">
    <div class="container">
      <!-- Logo -->
      <a class="navbar-brand" routerLink="/">
        <img [src]="logo" alt="Digital Alchemy Logo" class="navbar-logo">
      </a>
  
      <!-- Mobile Toggle Button -->
      <button 
        class="navbar-toggler" 
        type="button" 
        (click)="isCollapsed = !isCollapsed"
        [attr.aria-expanded]="!isCollapsed"
        aria-controls="navbarNav">
        <span class="navbar-toggler-icon"></span>
      </button>
  
      <!-- Navigation Menu -->
      <div class="collapse navbar-collapse" [class.show]="!isCollapsed" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          
          <!-- Accueil -->
          <li class="nav-item">
            <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="isCollapsed = true">
              Accueil
            </a>
          </li>
  
          <!-- Services Dropdown -->
          <li class="nav-item dropdown services-dropdown" [class.show]="isServicesDropdownOpen">
            <a 
              class="nav-link dropdown-toggle" 
              href="javascript:void(0)" 
              (click)="toggleServicesDropdown()"
              [class.active]="isServicesDropdownOpen">
              Services
            </a>
            <ul class="dropdown-menu" [class.show]="isServicesDropdownOpen">
              <li *ngFor="let service of services">
                <a class="dropdown-item" (click)="navigateToService(service.route)">
                  {{ service.title }}
                </a>
              </li>
            </ul>
          </li>
  
          <!-- À propos -->
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToSection('about')" style="cursor: pointer;">
              À propos
            </a>
          </li>
  
          <!-- Portfolio -->
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToSection('portfolio')" style="cursor: pointer;">
              Portfolio
            </a>
          </li>
  
          <!-- Contact -->
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToSection('contact')" style="cursor: pointer;">
              Contact
            </a>
          </li>
  
        </ul>
      </div>
    </div>
  </nav>